import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.10.1_sass@1.70.0_typescript@5.3.3_vite@5.0.12/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.10.1_sass@1.70.0_typescript@5.3.3_vite@5.0.12/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}